module.exports = __webpack_public_path__ + "img/congrats-badge.6c3a81c1.png";